var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',[_vm._t("icon-front"),_vm._t("default"),_vm._t("icon-back")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }